// extracted by mini-css-extract-plugin
export default {"color":"style_color__PsHvf","clockContainer":"style_clockContainer__NUKfD","clock":"style_clock__H+WH3","clockicon":"style_clockicon__skMsf"};